export const getCampaignId = (queryString?: string) => {
  if (!queryString) {
    return null;
  }

  const params = new URLSearchParams(queryString);

  return params.get("campaign_id");
};
